module.exports = __webpack_public_path__ + "img/home1.03b485b3.jpg";